// PHASE 8: How committed are you to this transformation?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'changeCommitment'

const OPTIONS = [
  {
    value: 'Fully committed - this is happening',
    translationKey:
      'pages.onboarding.v2.changeCommitment.options.fullyCommitted',
    emoji: '🔥',
  },
  {
    value: 'Very committed - ready to start',
    translationKey:
      'pages.onboarding.v2.changeCommitment.options.veryCommitted',
    emoji: '💪',
  },
  {
    value: 'Somewhat committed - exploring options',
    translationKey:
      'pages.onboarding.v2.changeCommitment.options.somewhatCommitted',
    emoji: '🤔',
  },
  {
    value: 'Just curious - no pressure',
    translationKey: 'pages.onboarding.v2.changeCommitment.options.justCurious',
    emoji: '👀',
  },
]

export default function ChangeCommitmentPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How committed are you to this transformation?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.changeCommitment.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
